import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App.js';
import { TeeTimeAppRoot } from './app/TeeTimeAppRoot.js';
import { installImportMetaEnvBridge } from './app/importMetaEnvBridge.js';
import './global.css';

installImportMetaEnvBridge(import.meta.env);

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');
const root = ReactDOM.createRoot(container);

const app = (
  <TeeTimeAppRoot>
    <App />
  </TeeTimeAppRoot>
);

// Ant Design v6 is not React 19 StrictMode-clean in this app yet; keep StrictMode off
// until the AntD stack is upgraded or the health diagnostics surface is migrated.
root.render(app);

// Web vitals telemetry (non-blocking)
// eslint-disable-next-line @typescript-eslint/no-empty-function
import('./app/webVitals.js').then(({ reportWebVitals }) => reportWebVitals()).catch(() => {});
